import { Injectable } from '@angular/core';
import { AuthHttpService } from '../auth-data/auth-http.service';
import { DocumentDataService } from '../document-data/document-data.service';
import { ITopLevelKeys } from '../entity-data/entity-data.data';
import { ErrorService } from '../error-reporting/error.service';
import { RendererService } from '../renderer/renderer.service';
import { GlobalSearch } from '../search-data/global-search.model';
import { SettingsDataStore } from '../settings-data/settings-data.store';
import { LoggerService } from '../shared/services/logger/logger.service';
import { CreditMemoDataBuilder } from './credit-memo-data.builder';

@Injectable()
export class CreditMemoDataService extends DocumentDataService {
  topLevelKeys: ITopLevelKeys = {
    getKey: 'credit_memo_snippets',
    postKey: 'created_credit_memo',
    putKey: 'updated_credit_memo',
    deletedKey: 'deleted_credit_memos',
    deleteSingleKey: 'deleted_credit_memo',
    getSingleKey: 'credit_memo',
    searchResultsKey: 'credit_memo_results',
    globalSearchResultsKey: GlobalSearch.KEYS.CREDIT_MEMOS,
  };

  constructor(
    authHttpService: AuthHttpService,
    loggerService: LoggerService,
    errorService: ErrorService,
    rendererService: RendererService,
    creditMemoDataBuilder: CreditMemoDataBuilder,
    settingsDataStore: SettingsDataStore
  ) {
    super(
      '/credit_memos',
      authHttpService,
      creditMemoDataBuilder,
      loggerService,
      rendererService,
      errorService,
      settingsDataStore
    );
  }
}
